// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"rgba%28255,255,255,0.05%29\"/><circle cx=\"20\" cy=\"80\" r=\"0.5\" fill=\"rgba%28255,255,255,0.05%29\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  min-height: 100vh;
  color: white;
}

.home-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
}

.welcome-section {
  text-align: center;
  margin-bottom: 40px;
}

.welcome-section h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
  font-weight: 800;
  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 4px 20px rgba(123, 61, 216, 0.2));
  letter-spacing: -0.03em;
}

.welcome-section p {
  font-size: 1.3rem;
  opacity: 0.9;
}

/* Стили для формы создания курса - КРУТОЙ ДИЗАЙН */
.create-course-section {
  background: linear-gradient(145deg, rgba(31, 41, 55, 0.9), rgba(17, 24, 39, 0.95));
  border-radius: 24px;
  padding: 40px;
  margin: 30px 0;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(123, 61, 216, 0.3);
  box-shadow: 
    0 25px 50px rgba(0, 0, 0, 0.4),
    0 0 40px rgba(123, 61, 216, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 650px;
  position: relative;
  overflow: hidden;
  animation: slideInUp 0.8s ease-out;
}

.create-course-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(123, 61, 216, 0.1), transparent);
  animation: shimmerEffect 3s infinite;
}

.create-course-section h2 {
  margin-bottom: 30px;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.02em;
  animation: glow 2s ease-in-out infinite alternate;
}

.playlist-form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-group {
  display: flex;
  flex-direction: column;
  position: relative;
}

.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 2px solid rgba(123, 61, 216, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.input-with-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(123, 61, 216, 0.1), transparent);
  transition: left 0.5s ease;
}

.input-with-icon:focus-within::before {
  left: 100%;
}

.input-with-icon:focus-within {
  border-color: #7b3dd8;
  box-shadow: 
    0 0 20px rgba(123, 61, 216, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.input-icon {
  position: absolute;
  left: 20px;
  color: #7b3dd8;
  pointer-events: none;
  z-index: 2;
  transition: all 0.3s ease;
  filter: drop-shadow(0 0 5px rgba(123, 61, 216, 0.3));
}

.input-with-icon:focus-within .input-icon {
  color: #9d4edd;
  transform: scale(1.1);
}

.playlist-input {
  padding: 20px 20px 20px 60px;
  border: none;
  border-radius: 14px;
  font-size: 1.1rem;
  background: transparent;
  color: white;
  transition: all 0.3s ease;
  width: 100%;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.playlist-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 400;
}

.playlist-input:focus {
  outline: none;
  color: white;
}

.playlist-input:disabled {
  background: rgba(255, 255, 255, 0.05);
  cursor: not-allowed;
  opacity: 0.6;
}

.create-button {
  padding: 18px 35px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 8px 25px rgba(123, 61, 216, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.create-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.create-button:hover::before {
  left: 100%;
}

.create-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 
    0 15px 35px rgba(123, 61, 216, 0.6),
    0 0 30px rgba(123, 61, 216, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  background: linear-gradient(135deg, #9d4edd 0%, #7b2cbf 100%);
}

.create-button:active {
  transform: translateY(-1px);
}

.create-button:disabled {
  background: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.5;
}

.create-button.loading {
  pointer-events: none;
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  opacity: 0.9;
  position: relative;
}

.create-button.loading::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  animation: shimmerLoading 1.5s linear infinite;
}

.create-button .spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes shimmerLoading {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 
      0 8px 25px rgba(123, 61, 216, 0.4),
      0 0 20px rgba(123, 61, 216, 0.3);
  }
  50% {
    box-shadow: 
      0 8px 25px rgba(123, 61, 216, 0.6),
      0 0 30px rgba(123, 61, 216, 0.5);
  }
}

@keyframes shimmerEffect {
  0% { left: -100%; }
  100% { left: 100%; }
}

@keyframes rotateGradient {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message {
  text-align: center;
  padding: 15px;
  border-radius: 10px;
  font-weight: 600;
  margin-top: 20px;
  animation: slideIn 0.3s ease;
}

.message.success {
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid rgba(76, 175, 80, 0.5);
  color: #4CAF50;
}

.message.error {
  background: rgba(244, 67, 54, 0.2);
  border: 1px solid rgba(244, 67, 54, 0.5);
  color: #f44336;
}

.message.warning {
  background: rgba(255, 193, 7, 0.2);
  border: 1px solid rgba(255, 193, 7, 0.5);
  color: #ff9800;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Адаптивность */
@media (max-width: 768px) {
  .welcome-section h1 {
    font-size: 2.5rem;
  }
  
  .create-course-section {
    padding: 20px;
    margin: 10px;
  }
  
  .home-content {
    padding: 20px 10px;
  }
}

.home-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

/* Hero Section */
.hero-section {
  padding: 80px 20px 60px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.hero-content {
  max-width: 600px;
  margin: 0 auto;
  animation: fadeInUp 0.8s ease-out;
}

.hero-title {
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  font-weight: 800;
  margin-bottom: 1.5rem;
  line-height: 1.1;
  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 4px 20px rgba(123, 61, 216, 0.2));
  letter-spacing: -0.03em;
  animation: fadeInUp 1s ease-out;
}

/* Main Content */
.main-content {
  position: relative;
  z-index: 1;
  padding: 0 20px 80px;
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
  background: #0A0A1B;
  border-radius: 24px;
  padding: 50px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: slideInUp 0.8s ease-out 0.2s both;
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-header h2 {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.02em;
}

.form-header p {
  font-size: 1.1rem;
  color: #718096;
  margin: 0;
}

/* Form Styling */
.playlist-form {
  margin-bottom: 60px;
}

.input-wrapper {
  position: relative;
  margin-bottom: 24px;
}

.submit-button {
  width: 100%;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 16px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
}

.submit-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.submit-button:hover::before {
  left: 100%;
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.submit-button svg {
  width: 20px;
  height: 20px;
}

.submit-button.loading {
  pointer-events: none;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Error Message */
.error-message {
  background: #fed7d7;
  color: #c53030;
  padding: 16px 20px;
  border-radius: 12px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #feb2b2;
  animation: shake 0.5s ease-in-out;
}

.error-message svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Features Grid */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.feature-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.feature-icon svg {
  width: 28px;
  height: 28px;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.1;
  }
  
  .form-container {
    padding: 30px 25px;
    margin: 0 10px;
  }
  
  .form-header h2 {
    font-size: 1.8rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .playlist-input {
    padding: 16px 16px 16px 50px;
    font-size: 1rem;
  }
  
  .submit-button {
    padding: 16px;
    font-size: 1rem;
  }
}

/* Progress Container Styles */
.progress-container {
  margin-top: 30px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 25px;
  backdrop-filter: blur(10px);
  animation: slideInUp 0.4s ease-out;
  max-height: 500px;
  overflow-y: auto;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.progress-header h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.02em;
}

.overall-progress {
  background: rgba(123, 61, 216, 0.2);
  color: #a855f7;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  border: 1px solid rgba(123, 61, 216, 0.3);
}

.stages-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 350px;
  overflow-y: auto;
}

.stage-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
}

.stage-item.active {
  background: rgba(123, 61, 216, 0.1);
  border-color: rgba(123, 61, 216, 0.3);
  box-shadow: 0 4px 20px rgba(123, 61, 216, 0.15);
}

.stage-item.completed {
  background: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.3);
}

.stage-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.stage-item.active .stage-icon {
  background: rgba(123, 61, 216, 0.3);
  color: #a855f7;
  box-shadow: 0 0 20px rgba(123, 61, 216, 0.4);
  animation: pulse 2s infinite;
}

.stage-item.completed .stage-icon {
  background: rgba(34, 197, 94, 0.3);
  color: #22c55e;
}

.stage-content {
  flex: 1 1;
  min-width: 0;
}

.stage-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.stage-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: fadeInUp 0.3s ease-out;
}

.stage-progress {
  display: flex;
  align-items: center;
  gap: 15px;
}

.progress-bar {
  flex: 1 1;
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #a855f7, #7c3aed);
  border-radius: 10px;
  transition: width 0.5s ease;
  position: relative;
  overflow: hidden;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shimmer 2s infinite;
}

.progress-text {
  color: #a855f7;
  font-size: 0.9rem;
  font-weight: 600;
  min-width: 80px;
  text-align: right;
}

.stage-detail-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  line-height: 1.4;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border-left: 3px solid #a855f7;
  font-family: 'Courier New', monospace;
}

/* Animations */
@keyframes pulse {
  0%, 100% { 
    transform: scale(1);
    box-shadow: 0 0 20px rgba(123, 61, 216, 0.4);
  }
  50% { 
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(123, 61, 216, 0.6);
  }
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design for Progress */
@media (max-width: 768px) {
  .progress-container {
    padding: 20px 15px;
    margin-top: 20px;
    max-height: 400px;
  }

  .progress-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .progress-header h3 {
    font-size: 1.2rem;
  }

  .stage-item {
    padding: 15px;
    gap: 12px;
  }

  .stage-icon {
    width: 40px;
    height: 40px;
  }

  .stage-label {
    font-size: 1rem;
  }

  .stage-progress {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .progress-text {
    text-align: left;
    min-width: auto;
  }

  .stage-detail-text {
    font-size: 0.85rem;
    padding: 10px 12px;
  }
  
  .stages-list {
    max-height: 250px;
  }
}

/* Custom Scrollbar for Progress Container */
.progress-container::-webkit-scrollbar,
.stages-list::-webkit-scrollbar {
  width: 6px;
}

.progress-container::-webkit-scrollbar-track,
.stages-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.progress-container::-webkit-scrollbar-thumb,
.stages-list::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #7b3dd8, #5707ab);
  border-radius: 3px;
}

.progress-container::-webkit-scrollbar-thumb:hover,
.stages-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #9d4edd, #7b2cbf);
}

/* Animation for titles */
.animated-title {
  animation: fadeInUp 0.8s ease-out both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uDAAuD;EACvD,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,kFAAkF;EAClF,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;EACzC;;;0CAGwC;EACxC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;EACzC,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB;;0CAEwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,UAAU;EACV,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD;;0CAEwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B;;;0CAGwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kGAAkG;EAClG,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE;;sCAEkC;EACpC;EACA;IACE;;sCAEkC;EACpC;AACF;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;;AAGA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAuf;EACvf,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uDAAuD;EACvD,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,2BAA2B;EAC3B,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;AACF;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4CAA4C;AAC5C;;EAEE,UAAU;AACZ;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;EAEE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".home-page {\n  min-height: 100vh;\n  color: white;\n}\n\n.home-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n}\n\n.welcome-section {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.welcome-section h1 {\n  font-size: 3.5rem;\n  margin-bottom: 20px;\n  font-weight: 800;\n  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 4px 20px rgba(123, 61, 216, 0.2));\n  letter-spacing: -0.03em;\n}\n\n.welcome-section p {\n  font-size: 1.3rem;\n  opacity: 0.9;\n}\n\n/* Стили для формы создания курса - КРУТОЙ ДИЗАЙН */\n.create-course-section {\n  background: linear-gradient(145deg, rgba(31, 41, 55, 0.9), rgba(17, 24, 39, 0.95));\n  border-radius: 24px;\n  padding: 40px;\n  margin: 30px 0;\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(123, 61, 216, 0.3);\n  box-shadow: \n    0 25px 50px rgba(0, 0, 0, 0.4),\n    0 0 40px rgba(123, 61, 216, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  width: 100%;\n  max-width: 650px;\n  position: relative;\n  overflow: hidden;\n  animation: slideInUp 0.8s ease-out;\n}\n\n.create-course-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(123, 61, 216, 0.1), transparent);\n  animation: shimmerEffect 3s infinite;\n}\n\n.create-course-section h2 {\n  margin-bottom: 30px;\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: -0.02em;\n  animation: glow 2s ease-in-out infinite alternate;\n}\n\n.playlist-form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.input-with-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  border: 2px solid rgba(123, 61, 216, 0.2);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.input-with-icon::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(123, 61, 216, 0.1), transparent);\n  transition: left 0.5s ease;\n}\n\n.input-with-icon:focus-within::before {\n  left: 100%;\n}\n\n.input-with-icon:focus-within {\n  border-color: #7b3dd8;\n  box-shadow: \n    0 0 20px rgba(123, 61, 216, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n.input-icon {\n  position: absolute;\n  left: 20px;\n  color: #7b3dd8;\n  pointer-events: none;\n  z-index: 2;\n  transition: all 0.3s ease;\n  filter: drop-shadow(0 0 5px rgba(123, 61, 216, 0.3));\n}\n\n.input-with-icon:focus-within .input-icon {\n  color: #9d4edd;\n  transform: scale(1.1);\n}\n\n.playlist-input {\n  padding: 20px 20px 20px 60px;\n  border: none;\n  border-radius: 14px;\n  font-size: 1.1rem;\n  background: transparent;\n  color: white;\n  transition: all 0.3s ease;\n  width: 100%;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.playlist-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 400;\n}\n\n.playlist-input:focus {\n  outline: none;\n  color: white;\n}\n\n.playlist-input:disabled {\n  background: rgba(255, 255, 255, 0.05);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.create-button {\n  padding: 18px 35px;\n  border: none;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  color: white;\n  font-size: 1.2rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: \n    0 8px 25px rgba(123, 61, 216, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  position: relative;\n  overflow: hidden;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.create-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.create-button:hover::before {\n  left: 100%;\n}\n\n.create-button:hover:not(:disabled) {\n  transform: translateY(-3px);\n  box-shadow: \n    0 15px 35px rgba(123, 61, 216, 0.6),\n    0 0 30px rgba(123, 61, 216, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  background: linear-gradient(135deg, #9d4edd 0%, #7b2cbf 100%);\n}\n\n.create-button:active {\n  transform: translateY(-1px);\n}\n\n.create-button:disabled {\n  background: rgba(255, 255, 255, 0.1);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n  opacity: 0.5;\n}\n\n.create-button.loading {\n  pointer-events: none;\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  opacity: 0.9;\n  position: relative;\n}\n\n.create-button.loading::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);\n  animation: shimmerLoading 1.5s linear infinite;\n}\n\n.create-button .spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-top: 2px solid #ffffff;\n  border-right: 2px solid #ffffff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes shimmerLoading {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    box-shadow: \n      0 8px 25px rgba(123, 61, 216, 0.4),\n      0 0 20px rgba(123, 61, 216, 0.3);\n  }\n  50% {\n    box-shadow: \n      0 8px 25px rgba(123, 61, 216, 0.6),\n      0 0 30px rgba(123, 61, 216, 0.5);\n  }\n}\n\n@keyframes shimmerEffect {\n  0% { left: -100%; }\n  100% { left: 100%; }\n}\n\n@keyframes rotateGradient {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message {\n  text-align: center;\n  padding: 15px;\n  border-radius: 10px;\n  font-weight: 600;\n  margin-top: 20px;\n  animation: slideIn 0.3s ease;\n}\n\n.message.success {\n  background: rgba(76, 175, 80, 0.2);\n  border: 1px solid rgba(76, 175, 80, 0.5);\n  color: #4CAF50;\n}\n\n.message.error {\n  background: rgba(244, 67, 54, 0.2);\n  border: 1px solid rgba(244, 67, 54, 0.5);\n  color: #f44336;\n}\n\n.message.warning {\n  background: rgba(255, 193, 7, 0.2);\n  border: 1px solid rgba(255, 193, 7, 0.5);\n  color: #ff9800;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .welcome-section h1 {\n    font-size: 2.5rem;\n  }\n  \n  .create-course-section {\n    padding: 20px;\n    margin: 10px;\n  }\n  \n  .home-content {\n    padding: 20px 10px;\n  }\n}\n\n.home-page::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"rgba(255,255,255,0.05)\"/><circle cx=\"20\" cy=\"80\" r=\"0.5\" fill=\"rgba(255,255,255,0.05)\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n  pointer-events: none;\n}\n\n/* Hero Section */\n.hero-section {\n  padding: 80px 20px 60px;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-content {\n  max-width: 600px;\n  margin: 0 auto;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.hero-title {\n  font-size: clamp(2.5rem, 6vw, 4.5rem);\n  font-weight: 800;\n  margin-bottom: 1.5rem;\n  line-height: 1.1;\n  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 4px 20px rgba(123, 61, 216, 0.2));\n  letter-spacing: -0.03em;\n  animation: fadeInUp 1s ease-out;\n}\n\n/* Main Content */\n.main-content {\n  position: relative;\n  z-index: 1;\n  padding: 0 20px 80px;\n}\n\n.form-container {\n  max-width: 800px;\n  margin: 0 auto;\n  background: #0A0A1B;\n  border-radius: 24px;\n  padding: 50px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: slideInUp 0.8s ease-out 0.2s both;\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.form-header h2 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem;\n  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.02em;\n}\n\n.form-header p {\n  font-size: 1.1rem;\n  color: #718096;\n  margin: 0;\n}\n\n/* Form Styling */\n.playlist-form {\n  margin-bottom: 60px;\n}\n\n.input-wrapper {\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.submit-button {\n  width: 100%;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  position: relative;\n  overflow: hidden;\n}\n\n.submit-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.submit-button:hover::before {\n  left: 100%;\n}\n\n.submit-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.submit-button svg {\n  width: 20px;\n  height: 20px;\n}\n\n.submit-button.loading {\n  pointer-events: none;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Error Message */\n.error-message {\n  background: #fed7d7;\n  color: #c53030;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid #feb2b2;\n  animation: shake 0.5s ease-in-out;\n}\n\n.error-message svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Features Grid */\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n  margin-top: 40px;\n}\n\n.feature-icon {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.feature-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-5px);\n  }\n  75% {\n    transform: translateX(5px);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1.1;\n  }\n  \n  .form-container {\n    padding: 30px 25px;\n    margin: 0 10px;\n  }\n  \n  .form-header h2 {\n    font-size: 1.8rem;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .playlist-input {\n    padding: 16px 16px 16px 50px;\n    font-size: 1rem;\n  }\n  \n  .submit-button {\n    padding: 16px;\n    font-size: 1rem;\n  }\n}\n\n/* Progress Container Styles */\n.progress-container {\n  margin-top: 30px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 25px;\n  backdrop-filter: blur(10px);\n  animation: slideInUp 0.4s ease-out;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.progress-header h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.02em;\n}\n\n.overall-progress {\n  background: rgba(123, 61, 216, 0.2);\n  color: #a855f7;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border: 1px solid rgba(123, 61, 216, 0.3);\n}\n\n.stages-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.stage-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  padding: 20px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: all 0.3s ease;\n}\n\n.stage-item.active {\n  background: rgba(123, 61, 216, 0.1);\n  border-color: rgba(123, 61, 216, 0.3);\n  box-shadow: 0 4px 20px rgba(123, 61, 216, 0.15);\n}\n\n.stage-item.completed {\n  background: rgba(34, 197, 94, 0.1);\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.stage-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.6);\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.stage-item.active .stage-icon {\n  background: rgba(123, 61, 216, 0.3);\n  color: #a855f7;\n  box-shadow: 0 0 20px rgba(123, 61, 216, 0.4);\n  animation: pulse 2s infinite;\n}\n\n.stage-item.completed .stage-icon {\n  background: rgba(34, 197, 94, 0.3);\n  color: #22c55e;\n}\n\n.stage-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.stage-label {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 8px;\n}\n\n.stage-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  animation: fadeInUp 0.3s ease-out;\n}\n\n.stage-progress {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.progress-bar {\n  flex: 1;\n  height: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #a855f7, #7c3aed);\n  border-radius: 10px;\n  transition: width 0.5s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  animation: shimmer 2s infinite;\n}\n\n.progress-text {\n  color: #a855f7;\n  font-size: 0.9rem;\n  font-weight: 600;\n  min-width: 80px;\n  text-align: right;\n}\n\n.stage-detail-text {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.95rem;\n  line-height: 1.4;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border-left: 3px solid #a855f7;\n  font-family: 'Courier New', monospace;\n}\n\n/* Animations */\n@keyframes pulse {\n  0%, 100% { \n    transform: scale(1);\n    box-shadow: 0 0 20px rgba(123, 61, 216, 0.4);\n  }\n  50% { \n    transform: scale(1.05);\n    box-shadow: 0 0 30px rgba(123, 61, 216, 0.6);\n  }\n}\n\n@keyframes shimmer {\n  0% { left: -100%; }\n  100% { left: 100%; }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design for Progress */\n@media (max-width: 768px) {\n  .progress-container {\n    padding: 20px 15px;\n    margin-top: 20px;\n    max-height: 400px;\n  }\n\n  .progress-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-start;\n  }\n\n  .progress-header h3 {\n    font-size: 1.2rem;\n  }\n\n  .stage-item {\n    padding: 15px;\n    gap: 12px;\n  }\n\n  .stage-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .stage-label {\n    font-size: 1rem;\n  }\n\n  .stage-progress {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .progress-text {\n    text-align: left;\n    min-width: auto;\n  }\n\n  .stage-detail-text {\n    font-size: 0.85rem;\n    padding: 10px 12px;\n  }\n  \n  .stages-list {\n    max-height: 250px;\n  }\n}\n\n/* Custom Scrollbar for Progress Container */\n.progress-container::-webkit-scrollbar,\n.stages-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.progress-container::-webkit-scrollbar-track,\n.stages-list::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n}\n\n.progress-container::-webkit-scrollbar-thumb,\n.stages-list::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #7b3dd8, #5707ab);\n  border-radius: 3px;\n}\n\n.progress-container::-webkit-scrollbar-thumb:hover,\n.stages-list::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(135deg, #9d4edd, #7b2cbf);\n}\n\n/* Animation for titles */\n.animated-title {\n  animation: fadeInUp 0.8s ease-out both;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
